import { SubscriptionProductType } from '../../../../../services/exports/Constants';

export default {
  title: 'Nuevo producto',
  fields: {
    type: {
      label: 'Tipo de producto',
      options: {
        [SubscriptionProductType.Plan]: 'Plan',
        [SubscriptionProductType.AddOn]: 'Complemento',
        [SubscriptionProductType.GoogleAdsPlan]: 'Plan de Google Ads',
      },
    },
    name: {
      label: 'Nombre interno',
      placeholder: 'Introduce el nombre interno del producto',
    },
    public_name: {
      label: 'Nombre público',
      placeholder: 'Introduce el nombre público del producto',
    },
    description: {
      label: 'Descripción',
    },
  },
  buttons: {
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  feedback: {
    missing_info: 'Información incompleta',
  },
  toasts: {
    plan_got_created: 'Producto creado',
    plan_got_updated: 'Producto actualizado',
  },
};
